import { CustomerInfo } from '../customer-info';
import { RegisterApplication } from '../register-application';
import { SharedDataService } from '../shared/shared-data/shared-data.service';
import { RestAPIService } from '../shared/shared-service/restAPI.service';
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import swal from 'sweetalert2';
import { BypassAuthGroupInfo } from './bypass-auth-group-info';
import { BypassAuthIpEmailInfo } from './bypass-auth-ip-email-info';

@Component({
  selector: 'app-register-application',
  templateUrl: './register-application.component.html',
  styleUrls: ['./register-application.component.scss']
})
export class RegisterApplicationComponent {
  successApiUrlTitle: string;
  failureApiUrlTitle: string;
  cyberscoreThresholdTitle: string;
  allowBypassOsTitle: string;
  allowFailureTitle: string;
  numberAttemptsAllowedTitle: string;
  timePeriodTitle: string;
  byPassValueSetGroup1: number[];
  byPassValueSetGroup2: number[];
  byPassValueSetGroup3: number[];
  customerInfo: CustomerInfo;
  validationMessages: any;
  portalConfigValuesFromS3: any;
  application: RegisterApplication = new RegisterApplication();
  isFailureAllow: boolean;
  byPassAppletCheck: boolean;
  byPassValueGroup1: number;
  emailValueGroup1: string;
  ipAddressGroup: string;
  byPassValueGroup2: number;
  emailValueGroup2: string;
  byPassValueGroup3: number;
  emailValueGroup3: string;
  group4DaysValue: number;
  gracePeriodApplyToAllUsersCheck: boolean = false;
  group4InfoText: string;
  emailErrorMessage: string;
  emailValidation: object;
  emailbyPassGroup: string;
  showOsByPass: boolean;
  dirRef1;
  allowLoginGracePeriod: string;
  allowBypassIpaddressTitle: string;
  enableRemediationTitle: string;
  skipAppletCheckAfterInstallingTitle: string;
  bypassAuthGroupInfo: BypassAuthGroupInfo = new BypassAuthGroupInfo();
  bypassAuthIpEmailInfo: BypassAuthIpEmailInfo = null;
  isValidForm: boolean = true;
  isValidCyberscore: boolean = true;
  isValidFailureTime: boolean = true;
  isValidFailedAttempts: boolean = true;
  enableRemediation: boolean;
  skipAppletCheckAfterInstalling: boolean;
  enablePhishing: boolean;
  enableSAT: boolean;
  thirdPartyServiceString: string;
  isValidHelpAttempt = true;
  helpAttemptsAllowedTitle: string;
  maxHelpButtonAttemptsAllowed: number;
  enableHelpTitle: string;
  enableHelp: boolean;


  constructor(private location: Location,
    private router: Router,
    private sharedDataService: SharedDataService, private restAPIService: RestAPIService) {

    this.customerInfo = this.sharedDataService.getCustomerInfo();
    this.validationMessages = this.sharedDataService.getValidationMessages();
    this.portalConfigValuesFromS3 = this.sharedDataService.getPortalConfigValuesFromS3();
    this.showOsByPass = false;
    this.application.firmName = this.customerInfo.firmName;
    this.application.firmId = this.customerInfo.firmId;
    this.application.bypassAuthentication = false;
    this.application.appletVerificationByPass = false;
    this.application.appletVerificationByPassGroups = JSON.parse('{}');
    this.isFailureAllow = false;
    this.byPassAppletCheck = false;
    this.application.appletcheckByPassIpaddress = false;
    this.skipAppletCheckAfterInstalling = false;
    this.enableRemediation = false;
    this.byPassValueSetGroup1 = [1, 2, 3, 4, 5, 15, 45, 60, 90];  //1 to 50
    this.byPassValueGroup1 = this.byPassValueSetGroup1[0];
    this.enablePhishing = false;
    this.enableSAT = false;
    this.byPassValueSetGroup2 = [120, 150, 180, 210];  //51 to 80
    this.byPassValueGroup2 = this.byPassValueSetGroup2[0];
    this.byPassValueSetGroup3 = [240, 270, 300, 365];  // Reamining values, untill 365 days
    this.byPassValueGroup3 = this.byPassValueSetGroup3[0];
    this.successApiUrlTitle = 'User is redirected to this URL if validation is successful. Typically, this is your application’s main page';
    this.failureApiUrlTitle = 'User is redirected to this URL if validation is not successful. Typically, this will force user to get logged out of your application.';
    this.cyberscoreThresholdTitle = 'Access is allowed only if the Unify cyberscore of user’s device is above this threshold.';
    this.allowBypassOsTitle = 'The Entreda Unify Authentication service is not supported in older operating systems (this includes Mac OS 10.9.x and 10.10.x). For these devices, do you want to bypass the authentication validation and allow such devices to login?';
    this.allowFailureTitle = 'Allow users to login to application if device does not meet cyberscore threshold for a number of attempts, over a fixed time period.  Upon expiration of the time period, the number of attempts where device does not meet cyberscore requirements, resets back to zero.';
    this.numberAttemptsAllowedTitle = 'Number of attempts a user can login without addressing cyberscore threshold requirements.';
    this.timePeriodTitle = 'Time period before number of attempts to login allowed resets back to zero.';
    this.enableRemediationTitle = 'Allow remediate failed items.';
    this.group4InfoText = 'If enabled, this will apply a Grace Period for installing the Enteda Application for all users under this registered Web Application';
    this.skipAppletCheckAfterInstallingTitle = 'Skip applet check afetr installation.';
    this.thirdPartyServiceString = "Additional user related services you want to integrate";
    this.enableHelp = false;
    this.enableHelpTitle = "If enabled , it will show 'Help' button on install and remediation screen , user can schedule appointment on click 'Help' button";
    this.helpAttemptsAllowedTitle = 'If a user leverages the Help option this many \ntimes without raising their Cyberscore above \nthe threshold, the Help option will be disabled \nfor that User.';
    this.application.maxHelpButtonAttempt = 0;
    this.maxHelpButtonAttemptsAllowed = 0;
  }

  ngOnInit() {
  }


  validateMaxFailedRetriesAttempts() {

    if (this.isFailureAllow && this.application.maxFailedRetriesAttempts !== null && (this.application.maxFailedRetriesAttempts > Number(this.portalConfigValuesFromS3.MAX_RETRIES_FAILED_PERIOD_AND_MAX_FAILED_RETRIES_ATTEMPTS) || this.application.maxFailedRetriesAttempts < Number(this.portalConfigValuesFromS3.MIN_RETRIES_FAILED_PERIOD_AND_MAX_FAILED_RETRIES_ATTEMPTS))) {
      $("#maxFailedRetriesAttemptsRangeErrorDiv").show();
      this.isValidForm = false;
      this.isValidFailedAttempts = false;
    } else {
      $("#maxFailedRetriesAttemptsRangeErrorDiv").hide();
      this.isValidFailedAttempts = true;
      if (this.isValidCyberscore && this.isValidFailureTime) {
        this.isValidForm = true;
      }
    }
  }

  validateRetriesFailedPeriod() {
    if (this.isFailureAllow && this.application.retriesFailedPeriod !== null && (this.application.retriesFailedPeriod > Number(this.portalConfigValuesFromS3.MAX_RETRIES_FAILED_PERIOD_AND_MAX_FAILED_RETRIES_ATTEMPTS) || this.application.retriesFailedPeriod < Number(this.portalConfigValuesFromS3.MIN_RETRIES_FAILED_PERIOD_AND_MAX_FAILED_RETRIES_ATTEMPTS))) {
      $("#retriesFailedPeriodRangeErrorDiv").show();
      this.isValidForm = false;
      this.isValidFailureTime = false;
    } else {
      $("#retriesFailedPeriodRangeErrorDiv").hide();
      this.isValidFailureTime = true;
      if (this.isValidCyberscore && this.isValidFailedAttempts) {
        this.isValidForm = true;
      }

    }
  }

  validateGroupDays(allowGracePeriod: boolean) {
    if (allowGracePeriod) {
      this.validateGroup4Days();
      this.byPassValueGroup1 = this.byPassValueSetGroup1[0];
      this.byPassValueGroup2 = this.byPassValueSetGroup2[0];
      this.byPassValueGroup3 = this.byPassValueSetGroup3[0];
    } else {
      this.gracePeriodApplyToAllUsersCheck = false;
      this.isValidForm = true;
      $('#group4DaysRequiredDiv').hide();
    }
  }

  validateGroup4Days() {
    if (this.byPassAppletCheck) {
    if (
      this.gracePeriodApplyToAllUsersCheck &&
      (this.group4DaysValue === undefined || this.group4DaysValue === null)
    ) {
      this.isValidForm = false;
      $('#group4DaysRequiredDiv').show();
    } else {
      this.isValidForm = true;
      $('#group4DaysRequiredDiv').hide();
    }
  }else {
    this.isValidForm = true;
      $('#group4DaysRequiredDiv').hide();
  }
}

  validateCyberscoreThresholdRange() {

    if (this.application.cyberScoreThreshold !== null && (this.application.cyberScoreThreshold > 800 || this.application.cyberScoreThreshold < 1)) {
      $("#cyberScoreThresholdRangeErrorDiv").show();
      this.isValidForm = false;
      this.isValidCyberscore = false;
    } else {
      $("#cyberScoreThresholdRangeErrorDiv").hide();
      this.isValidCyberscore = true;
      if (this.isValidFailureTime && this.isValidFailedAttempts) {
        this.isValidForm = true;
      }
    }
  }


  resetData(): void {
    this.isFailureAllow = true;
    this.application.maxFailedRetriesAttempts = null;
    this.application.retriesFailedPeriod = null;

    this.validateMaxFailedRetriesAttempts();
    this.validateRetriesFailedPeriod();
  }

  clearData(): void {
    this.isFailureAllow = false;
    this.application.maxFailedRetriesAttempts = 0;
    this.application.retriesFailedPeriod = 0;
    $("#retriesFailedPeriodRangeErrorDiv").hide();
    $("#maxFailedRetriesAttemptsRangeErrorDiv").hide();

    this.isValidFailedAttempts = true;
    this.isValidFailureTime = true;
    if (this.isValidCyberscore) {
      this.isValidForm = true;
    }
  }

  validateMaxHelpAttempts(){
      if (this.enableHelp &&
        this.application.maxHelpButtonAttempt !== null &&
        (this.application.maxHelpButtonAttempt > 999 ||
          this.application.maxHelpButtonAttempt < 1)) {
        $('#maxHelpButtonAttemptRangeErrorDiv').show();
        this.isValidForm = false;
        this.isValidFailedAttempts = false;
      } else {
        $('#maxHelpButtonAttemptRangeErrorDiv').hide();
        this.isValidForm = true;
        this.isValidFailedAttempts = true;
      }
    }

    resetHelpButtonData(): void {
      this.enableHelp = true;
      this.application.maxHelpButtonAttempt = this.maxHelpButtonAttemptsAllowed;
      this.validateMaxHelpAttempts();
    }

    clearHelpButtonData(): void {
      this.enableHelp = false;
      this.application.maxHelpButtonAttempt = 0;
      this.maxHelpButtonAttemptsAllowed = 0;
      $('#maxHelpButtonAttemptRangeErrorDiv').hide();
      this.isValidFailedAttempts = true;
      if (this.isValidCyberscore) {
        this.isValidForm = true;
      }
    }

  registerApplication(): void {

    this.application.enableRemediation = this.enableRemediation;
    this.application.isHelpEnabled = this.enableHelp;
    this.application.skipAppletCheckAfterInstalling = this.skipAppletCheckAfterInstalling;
    if (!this.isFailureAllow) {
      this.application.maxFailedRetriesAttempts = 0;
      this.application.retriesFailedPeriod = 0;
    }
    if(!this.enableHelp){
       this.application.maxHelpButtonAttempt = 0;
    }

    //If the user slect yes on the skip applet allow check and entererd the number of days (Ex: 6)
    //and then changed the option back to no without changing the value then we should conside the value as 0
    this.application.appletVerificationByPass = this.byPassAppletCheck;
    this.application.gracePeriodApplyToAllUsers = this.gracePeriodApplyToAllUsersCheck;
    if (this.byPassAppletCheck) {
      this.bypassAuthGroupInfo.group1Days = this.byPassValueGroup1;
      this.bypassAuthGroupInfo.group2Days = this.byPassValueGroup2;
      this.bypassAuthGroupInfo.group3Days = this.byPassValueGroup3;

      this.bypassAuthGroupInfo.group1Emails = this.emailValueGroup1;
      this.bypassAuthGroupInfo.group2Emails = this.emailValueGroup2;
      this.bypassAuthGroupInfo.group3Emails = this.emailValueGroup3;
      this.application.gracePeriodApplyToAllUsers = this.gracePeriodApplyToAllUsersCheck;

      this.application.appletVerificationByPassGroups = JSON.stringify(this.bypassAuthGroupInfo);
    }
    else {
      this.application.appletVerificationByPassGroups = '{}';
    }

    if (this.application.appletcheckByPassIpaddress) {
      this.bypassAuthIpEmailInfo = new BypassAuthIpEmailInfo();
      this.bypassAuthIpEmailInfo.emailList = this.emailbyPassGroup;
      this.bypassAuthIpEmailInfo.ipAddressList = this.ipAddressGroup;

      this.application.appletCheckByPassIpaddressList = JSON.stringify(this.bypassAuthIpEmailInfo);
    }
    else {
      this.application.appletCheckByPassIpaddressList = '{}';
    }
    let finalThirdPartyStr = "";
    if (this.enablePhishing && this.enableSAT) {
      finalThirdPartyStr += "Phishing".concat(",").concat("SAT");
    }
    else if (this.enablePhishing) {
      finalThirdPartyStr = "Phishing";
    }
    else if (this.enableSAT) {
      finalThirdPartyStr = "SAT";
    }
    this.application.thirdPartyServicesActivated = finalThirdPartyStr;
    this.restAPIService.registerApplication(this.application).then(customerApplication => {
      this.alertAPIkey(customerApplication.apiKey); this.goDashboard();
    }).catch(error => {
      this.sharedDataService.showError(error.message);
    });
  }

  goBack(): void {
    this.location.back();
  }
  alertAPIkey(apiKey: string): void {
    swal('Application APIkey', apiKey, 'info');
  }
  goDashboard(): void {
    this.router.navigate(['/layout/dashboard']);
  }
  toggleSatUI() {
    this.enableSAT = this.enableSAT ? false : true;
  }
  togglePhishingUI() {
    this.enablePhishing = this.enablePhishing ? false : true;
  }

}
